import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { bulkTicketExampleFile } from "../actions/service_request";


export const generateCSV = (headers) => {
    if (!headers || headers.length === 0) {
        console.error("Headers array is empty or undefined");
        return;
    }

    const formattedHeaders = headers.map(header => {
        return header.split(/[_-]/)
            .map(word => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
    });

    const csvContent = formattedHeaders.join(",") + "\n";

    const blob = new Blob([csvContent], { type: "text/csv" });
    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    a.download = "data.csv";
    document.body.appendChild(a);
    a.click();

    document.body.removeChild(a);
    URL.revokeObjectURL(url);
};

const DownloadCSVButton = ({ type }) => {
    const dispatch = useDispatch();

    const handleDownload = (e) => {
        e.preventDefault()
        dispatch(bulkTicketExampleFile({ type }));
    };

    return <span className="text-scogoorange px-4 py-2 cursor-pointer" onClick={handleDownload}>Download Sample File(CSV)</span>;
};

export default DownloadCSVButton;

